var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipsis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 16C16.75 16.1483 16.706 16.2933 16.6236 16.4167C16.5412 16.54 16.4241 16.6361 16.287 16.6929C16.15 16.7497 15.9992 16.7645 15.8537 16.7356C15.7082 16.7067 15.5746 16.6352 15.4697 16.5303C15.3648 16.4254 15.2934 16.2918 15.2644 16.1463C15.2355 16.0008 15.2503 15.85 15.3071 15.713C15.3639 15.5759 15.46 15.4588 15.5833 15.3764C15.7067 15.294 15.8517 15.25 16 15.25C16.1989 15.25 16.3897 15.329 16.5303 15.4697C16.671 15.6103 16.75 15.8011 16.75 16ZM16 12.5C16.1483 12.5 16.2933 12.456 16.4167 12.3736C16.54 12.2912 16.6361 12.1741 16.6929 12.037C16.7497 11.9 16.7645 11.7492 16.7356 11.6037C16.7067 11.4582 16.6352 11.3246 16.5303 11.2197C16.4254 11.1148 16.2918 11.0434 16.1463 11.0144C16.0008 10.9855 15.85 11.0003 15.713 11.0571C15.5759 11.1139 15.4588 11.21 15.3764 11.3333C15.294 11.4567 15.25 11.6017 15.25 11.75C15.25 11.9489 15.329 12.1397 15.4697 12.2803C15.6103 12.421 15.8011 12.5 16 12.5ZM16 19.5C15.8517 19.5 15.7067 19.544 15.5833 19.6264C15.46 19.7088 15.3639 19.8259 15.3071 19.963C15.2503 20.1 15.2355 20.2508 15.2644 20.3963C15.2934 20.5418 15.3648 20.6754 15.4697 20.7803C15.5746 20.8852 15.7082 20.9567 15.8537 20.9856C15.9992 21.0145 16.15 20.9997 16.287 20.9429C16.4241 20.8861 16.5412 20.79 16.6236 20.6667C16.706 20.5433 16.75 20.3983 16.75 20.25C16.75 20.0511 16.671 19.8603 16.5303 19.7197C16.3897 19.579 16.1989 19.5 16 19.5Z",
    fill: "#131515"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#ECEEEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsis);
export default __webpack_public_path__ + "static/media/ellipsis.60889ab53f5a4e5f9956d73b6c632abf.svg";
export { ForwardRef as ReactComponent };